import { createApp }   from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import './styles/theme.css'

import App    from './components/App.vue'
import router from './router/index'
import { useAuthStore } from './stores/auth'

const pinia   = createPinia()
const vuetify = createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: 'lecoq',
    themes: {
      lecoq: {
        dark: false,
        colors: {
          background: '#f5efe3',
          surface: '#f5efe3',
          primary: '#0f2f56',
          secondary: '#264f6d',
          accent: '#b01211',
          error: '#b01211',
          warning: '#c47a12',
          info: '#264f6d',
          success: '#2f6b4f',
          'on-background': '#0f2f56',
          'on-surface': '#0f2f56',
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-error': '#ffffff',
        },
        variables: {
          'high-emphasis-opacity': 1,
          'medium-emphasis-opacity': 0.82,
          'border-opacity': 0.32,
        },
      },
      lecoqDark: {
        dark: true,
        colors: {
          background: '#0a1a2e',
          surface: '#12263f',
          primary: '#7eb6e8',
          secondary: '#9bb8cc',
          accent: '#e85a58',
          error: '#e85a58',
          warning: '#e0a04a',
          info: '#7eb6e8',
          success: '#6db38d',
          'on-background': '#eef3f6',
          'on-surface': '#eef3f6',
          'on-primary': '#0a1a2e',
          'on-secondary': '#0a1a2e',
          'on-error': '#0a1a2e',
        },
        variables: {
          'high-emphasis-opacity': 1,
          'medium-emphasis-opacity': 0.88,
          'border-opacity': 0.4,
        },
      },
    },
  },
  defaults: {
    VBtn: { rounded: 'lg', elevation: 0 },
    VCard: { rounded: 'xl', elevation: 2, border: false },
    VTextField: { variant: 'outlined', color: 'primary' },
    VSelect: { variant: 'outlined', color: 'primary' },
    VChip: { rounded: 'lg' },
    VAppBar: { elevation: 0, color: 'primary' },
    VBottomNavigation: { color: 'primary', elevation: 8 },
  },
  icons: { defaultSet: 'mdi' },
})

const app = createApp(App)
app.use(pinia).use(vuetify)

// Restore session BEFORE registering the router so beforeEach has accurate state
useAuthStore().fetchMe().then(() => {
  app.use(router)
  app.mount('#app')
})

// PWA: register after load so it does not compete with boot /auth/me
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* non-secure context or missing asset — ignore */
    })
  })
}
